module.exports = __webpack_public_path__ + "media/images/icon__infoBox-5877d8ed2d1dadb8f185b0646fb3cee7.png";